import { FC } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

import { I18nLoader } from '../../libs/I18nLoader';

import { LanguageRouterProps } from './LanguageRouter.types';

export const LanguageRouter: FC<LanguageRouterProps> = ({ children }) => {
  return (
    <div className="App">
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <Routes>
          <Route path=":language/*" element={<I18nLoader>{children}</I18nLoader>} />
          <Route path="*" element={<Navigate to="/nl" />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
};
